import { FileText } from "@ews-admin/global-design-system";
import React from "react";
import { useTranslation } from "react-i18next";
import { Facility } from "@/types/facility.definition";

interface AboutUsTabProps {
  facility: Facility;
  setFacility: React.Dispatch<React.SetStateAction<Facility>>;
}

export const AboutUsTab: React.FC<AboutUsTabProps> = ({
  facility,
  setFacility,
}) => {
  const { t } = useTranslation();

  const value = facility.aboutUs ?? "";
  const MIN_LENGTH = 200;
  const isBelowMin = value.length > 0 && value.length < MIN_LENGTH;

  return (
    <div className="space-y-6">
      <div className="space-y-4">
        <div className="flex items-center mb-4 space-x-3">
          <div className="flex justify-center items-center w-8 h-8 rounded-lg bg-warning-100">
            <FileText className="w-4 h-4 text-warning-600" />
          </div>
          <h3 className="text-lg font-semibold text-neutral-900">
            {t("facilityAbout.title")}
          </h3>
        </div>

        <div className="space-y-1">
          <label className="block text-sm font-medium text-neutral-700">
            {t("facilityAbout.label")}
          </label>
          <textarea
            rows={6}
            value={value}
            onChange={(e) =>
              setFacility((prev) => ({ ...prev, aboutUs: e.target.value }))
            }
            placeholder={t("facilityAbout.placeholder")}
            className="w-full px-3 py-2 text-sm rounded-lg border border-neutral-300 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500 resize-y transition-all duration-200 text-neutral-900 placeholder-neutral-400"
          />
          {isBelowMin && (
            <p className="text-xs text-red-500">
              {t("facilityAbout.minLengthError")}
            </p>
          )}
          <p
            className={`text-xs ${
              isBelowMin ? "text-red-500" : "text-neutral-500"
            }`}
          >
            {t("facilityAbout.charCount", { count: value.length, min: MIN_LENGTH })}
          </p>
        </div>
      </div>
    </div>
  );
};
